import { render } from "./EquipmentIcon.vue?vue&type=template&id=3ac45c8a&scoped=true"
const script = {}

import "./EquipmentIcon.vue?vue&type=style&index=0&id=3ac45c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac45c8a"]])

export default __exports__